module.exports = __webpack_public_path__ + "img/notification-base.bc3da4e6.svg";